import {
  Component, ViewChild, EventEmitter, Output, OnInit, AfterViewInit, Input, forwardRef,
  OnChanges
} from '@angular/core';
import {
  FormGroup, FormBuilder, NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor,
  FormControl
} from '@angular/forms';
import { MapsAPILoader } from '@agm/core';


@Component({
    selector: 'app-google-place-autocomplete',
    template: `<mat-form-field fxFlexFill appearance="outline" >
      <mat-label>Address</mat-label>
      <input 
        matInput
        placeholder="Address"
        [(ngModel)]="autocompleteInput"
        #addresstext required
        (ngModelChange)="onAddressChanged($event)"
        autocomplete="off"
        >
        <mat-icon matSuffix fontSet="fa" fontIcon="fa-map-marker-alt"></mat-icon>
        </mat-form-field>
    `,
    providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => GooglePlacesAutocompleteComponent), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => GooglePlacesAutocompleteComponent), multi: true }
  ]
})
export class GooglePlacesAutocompleteComponent implements OnInit, AfterViewInit, ControlValueAccessor, OnChanges {
    @Input() adressType: string;
    @Input('address') _address = 0;
    @Output() setAddress: EventEmitter<any> = new EventEmitter();
    @ViewChild('addresstext') addresstext: any;

    propagateChange:any = () => {};
    validateFn:any = () => {};

    autocompleteInput: string;
    queryWait: boolean;

    get address() {
      return this._address;
    }

    set address(val) {
      this._address = val;
      this.autocompleteInput = String(val);
      this.propagateChange(val);
    }

    constructor(private mapsAPILoader: MapsAPILoader) {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.getPlaceAutocomplete();
    }

    writeValue(value) {
      if (value) {
        this.address = value;
      }
    }

    registerOnChange(fn) {
      this.propagateChange = fn;
    }

    registerOnTouched() {}

    ngOnChanges(inputs) {
      this.propagateChange(this.address);
      if (inputs.counterRangeMax || inputs.counterRangeMin) {
        //this.validateFn = createCounterRangeValidator(this.counterRangeMax, this.counterRangeMin);
        this.propagateChange(this.address);
      }
    }

    validate(c: FormControl) {
      return this.validateFn(c);
    }

    private getPlaceAutocomplete() {
      this.mapsAPILoader.load().then(() => {
        const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
            {
                componentRestrictions: { country: 'CA' },
                types: [this.adressType]  // 'establishment' / 'address' / 'geocode'
            });
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            const place = autocomplete.getPlace();
            this.invokeEvent(place);
        });
      });
    }

    onAddressChanged(event) {
      this.address = event;
    }

    invokeEvent(place: Object) {
        this.setAddress.emit(place);
        this.address = place['formatted_address'];
    }

}
